import React from 'react'
import NextBtn from './NextBtn.jsx'
import PrevBtn from './PrevBtn.jsx'
import NextBtnCatalog from './NextBtnCatalog.jsx'
import PrevBtnCatalog from './PrevBtnCatalog.jsx'
import Tooltip from '../tooltip/Tooltip.jsx'
import { prevNextProps } from '../types'
const PrevNext = props => {
    const paginatorToggle = () => {
        let paginatorOpen = props.paginatorOpen
        if (paginatorOpen === 'half' || paginatorOpen === 'full') {
            props.setPaginatorState('closed')
        } else {
            props.setPaginatorState('half')
            setTimeout(() => {
                const focusablePaginator = document.querySelector(
                    '.js-paginator'
                )
                focusablePaginator.focus()
            }, 250)
        }
        document.querySelector('.js-paginator').style.removeProperty('height')
    }
    const paginatorLabel = () => {
        let currentState = props.paginatorOpen
        if (currentState == 'half' || currentState == 'full') {
            return 'Hide Paginator'
        } else {
            return 'Show Paginator'
        }
    }
    const renderTrayIcon = () => {
        return (
            <Tooltip tooltipText={paginatorLabel()} tooltipPosition="above">
                <button
                    className="paginator__btn"
                    onClick={() => paginatorToggle()}
                    type="button"
                >
                    <span className="handle-icon" />
                    <span className="visually-hidden">{paginatorLabel()}</span>
                </button>
            </Tooltip>
        )
    }

    const renderPrevButton = viewerType => {
        if (viewerType === 'catalog') {
            return (
                <PrevBtnCatalog
                    paginatorOpen={props.paginatorOpen}
                    currentView={props.currentView}
                />
            )
        } else {
            return (
                <PrevBtn
                    paginatorOpen={props.paginatorOpen}
                    currentView={props.currentView}
                />
            )
        }
    }

    const renderNextButton = viewerType => {
        if (viewerType === 'catalog') {
            return (
                <NextBtnCatalog
                    paginatorOpen={props.paginatorOpen}
                    currentView={props.currentView}
                />
            )
        } else {
            return (
                <NextBtn
                    paginatorOpen={props.paginatorOpen}
                    currentView={props.currentView}
                />
            )
        }
    }

    return (
        <div className="page-nav">
            {renderPrevButton(props.viewerType)}
            <div className="page-nav__titles">
                <span className="page-nav__title"> {props.leftTitle}</span>
                {renderTrayIcon()}
                <span className="page-nav__title page-nav__title--right">
                    {props.rightTitle}
                </span>
            </div>
            {renderNextButton(props.viewerType)}
        </div>
    )
}

export default PrevNext

PrevNext.propTypes = prevNextProps
